import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { produce } from "../../../../../../../../../../../libs/immer";
import { EModalStep } from "../../../../../ModalLayout/EModalStep";
export var getChangePaymentTypeButtonProps = function getChangePaymentTypeButtonProps(_ref) {
  var getContent = _ref.getContent,
    getIsMobile = _ref.getIsMobile,
    getIsLoggedIn = _ref.getIsLoggedIn,
    getIconProps = _ref.getIconProps;
  return function (getState, setState) {
    var state = getState();
    var content = getContent();
    var isMobile = getIsMobile();
    var isLoggedIn = getIsLoggedIn();
    if (!isLoggedIn) return undefined;
    if (!isMobile) return undefined;
    var optionProps = [state.options.map(function (o) {
      return _objectSpread(_objectSpread({}, o), getIconProps(o));
    }), state.quickOptions.map(function (o) {
      return _objectSpread(_objectSpread({}, o), getIconProps(o));
    })].flat().find(function (_ref2) {
      var id = _ref2.id;
      return id === state.selectedPaymentId;
    });
    return {
      title: content.changePaymentButton.title,
      buttonProps: {
        children: content.changePaymentButton.buttonText,
        onClick: function onClick() {
          setState(function (prev) {
            return produce(prev, function (draft) {
              draft.mobileStep = EModalStep.PaymentType;
            });
          });
        },
        disabled: false
      },
      optionProps: optionProps
    };
  };
};